import React, { useEffect } from 'react';
import styled from 'styled-components';
import gsap from 'gsap';
import Logo from 'public/logo-pink-sun.svg';

const InitialLoader = () => {
  const [isLoading, setIsLoading] = React.useState(true);

  const loaderRef = React.useRef<HTMLDivElement>(null);

  const closeLoader = () => {
    if (!loaderRef.current) return;

    gsap.to(loaderRef.current, {
      duration: 0.8,
      opacity: 0,
      display: 'powr4.inOut',
      onComplete: () => {
        setIsLoading(false);
        document.body.style.overflow = 'auto';
      },
    });
  };

  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      closeLoader();
    }, 2000);

    const observer = new PerformanceObserver((list) => {
      const entries = list.getEntriesByType(
        'resource',
      ) as PerformanceResourceTiming[];

      if (entries && entries.length > 0) {
        const ongoingRequests = entries.filter(
          (entry) => entry.transferSize === 0 && entry.duration === 0,
        );

        if (ongoingRequests.length === 0) {
          clearTimeout(initialTimeout); // Clear the timeout to prevent it from hiding the loader again
          setTimeout(() => {
            closeLoader();
          }, 1000);
          observer.disconnect();
        }
      }
    });

    observer.observe({ entryTypes: ['resource'] });

    return () => {
      clearTimeout(initialTimeout);
      observer.disconnect();
    };
  }, []);

  if (!isLoading) {
    return null;
  }

  return (
    <StyledLoaderWrapper ref={loaderRef} className="loader-wrapper">
      <LogoWrapper className="loader">
        <LogoStyled src={Logo} width={72}></LogoStyled>
      </LogoWrapper>
    </StyledLoaderWrapper>
  );
};

const StyledLoaderWrapper = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: ${({ theme }) => theme.zIndex.loader};
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LogoWrapper = styled.div`
  background-color: transparent;
  border: none;
  box-shadow: none;
  padding: 0;
  height: 4.5rem;
  width: 4.5rem;
  outline: none;

  &:focus {
    outline: none;
    box-shadow: none;
  }

  &:focus-visible {
    outline: none;
    box-shadow: none;
  }
`;

const LogoStyled = styled.img`
  width: 4.5rem;
  height: 4.5rem;
  border: none;
  box-shadow: none;
  animation: pulseOpacity 2s ease-in-out infinite;

  @keyframes pulseOpacity {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
`;

export default InitialLoader;
